import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { content } from "../../data/content";

export function EditorialMarquee() {
  const items = [content.marqueeText, content.marqueeSub];
  return (
    <section
      data-testid="marquee-section"
      className="w-full bg-sun border-y-[3px] border-ink py-6 md:py-8 overflow-hidden"
    >
      <Marquee speed={40} gradient={false}>
        {[...Array(4)].map((_, i) => (
          <span key={i} className="flex items-center">
            {items.map((t, j) => (
              <span key={j} className="flex items-center">
                <span
                  className={`font-heading font-black uppercase tracking-tight text-4xl md:text-7xl mx-6 ${
                    j % 2 === 0 ? "text-ink" : "text-outline-rose"
                  }`}
                >
                  {t}
                </span>
                <Star
                  className="w-8 h-8 md:w-12 md:h-12 text-rose mx-2 fill-rose"
                  strokeWidth={2}
                />
              </span>
            ))}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
